import { useSelector } from 'react-redux';
import { selectSpecialistId } from '../redux/slices/booking';
import { checkIfSelectedSpecialistIsNurse } from '../utils/specialist';

export const useBookingFLowType = (): string => {
  const specialistId = useSelector(selectSpecialistId);
  const isNurseFlow = checkIfSelectedSpecialistIsNurse(specialistId);
  return isNurseFlow ? 'nurse' : 'specialist';
};
